import React, { useEffect, useState } from "react";
import { getSchema } from "../api/schema.api";
import { SchemaRow } from "../api/schema.type";

// Placeholder for fetching DB schema. Replace with real API call.

const dbOptions = ["medical", "reference", "main", "clickhouse"] as const;
type DbName = (typeof dbOptions)[number];

export const AdminDbPage: React.FC = () => {
  const [selectedDb, setSelectedDb] = useState<DbName>("medical");
  const [columns, setColumns] = useState<SchemaRow[]>([]);
  const [tables, setTables] = useState<string[]>([]);

  function getUniqueTables(columns: SchemaRow[]) {
    return columns.map((column) => column.table_name);
  }

  useEffect(() => {
    const loadSchema = async () => {
      const data = await getSchema(selectedDb);
      const uniqueTables = getUniqueTables(data);
      setTables(uniqueTables);
      setColumns(data);
    };

    loadSchema();
  }, [selectedDb]);

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-bold mb-4">Database Schema</h2>

      <div className="mb-6">
        <label htmlFor="db-select" className="mr-2 font-medium">
          Select database:
        </label>
        <select
          id="db-select"
          value={selectedDb}
          onChange={(e) => setSelectedDb(e.target.value as DbName)}
          className="border rounded px-2 py-1"
        >
          {dbOptions.map((db) => (
            <option key={db} value={db}>
              {db}
            </option>
          ))}
        </select>
      </div>

      {tables.map((table) => (
        <div key={table} className="mb-8">
          <h3 className="text-xl font-semibold mb-2">{table}</h3>
          <table className="min-w-full bg-white border">
            <thead>
              <tr>
                <th className="py-2 px-4 border-b text-left">Column</th>
                <th className="py-2 px-4 border-b text-left">Type</th>
              </tr>
            </thead>
            <tbody>
              {columns
                .filter((col) => col.table_name === table)
                .map((col) => (
                  <tr key={col.column_name}>
                    <td className="py-1 px-4 border-b">{col.column_name}</td>
                    <td className="py-1 px-4 border-b">{col.data_type}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};

export default AdminDbPage;
